module.exports = __webpack_public_path__ + "media/images/ninestars/team/team-4-1667f1691c64c26197cda84399a1079a.jpg";